import './bootstrap';

import Swal from 'sweetalert2';
window.Swal = Swal;

import Quill from 'quill';
import 'quill/dist/quill.snow.css';
window.Quill = Quill;

import $ from 'jquery';
import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/mouse'
import 'jquery-ui/ui/widgets/slider'
import 'jquery-ui/themes/base/slider.css'

window.$ = $;
window.jQuery = $;

import DataTable from 'datatables.net-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'

import Slider from 'bootstrap-slider'     // 👈 IMPORT FONDAMENTALE
import 'bootstrap-slider/dist/css/bootstrap-slider.css'  // 👈 Stili
window.Slider = Slider;

import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js'
//import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.it-CH.min.js'

const script = document.createElement('script');
script.src = '/vendor/bootstrap-datepicker.it-CH.min.js';
document.head.appendChild(script);

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

// Rendi toastr globale (opzionale ma comodo)
window.toastr = toastr

import '@vueform/multiselect/themes/default.css';

// resources/js/app.js

//questi per essere importati vanno installati da NPM
//import '../../public/vendor/jquery/jquery.min.js';
//import '../../public/vendor/bootstrap/js/bootstrap.bundle.min.js';
//import '../../public/vendor/overlayScrollbars/js/jquery.overlayScrollbars.min.js';
//import '../../public/vendor/adminlte/dist/js/adminlte.min.js';

import '../../public/vendor/fontawesome-free/css/all.min.css';
import '../../public/vendor/overlayScrollbars/css/OverlayScrollbars.min.css';
import '../../public/vendor/adminlte/dist/css/adminlte.min.css';
import '../../public/vendor/adminlte/dist/css/google-fonts.css';
import '@fortawesome/fontawesome-free/css/all.min.css';